import { Fragment } from "react"
import { Link } from "react-router-dom"

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { useRouteMatches } from "@/components/layout/route-handle"

export function AppBreadcrumbs() {
  const matches = useRouteMatches()

  // Index routes share their parent's pathname; the deepest label for a path wins.
  const labels = new Map<string, string>()
  for (const match of matches) {
    if (match.handle?.crumb) labels.set(match.pathname.replace(/\/$/, "") || "/", match.handle.crumb)
  }
  const crumbs = [...labels].map(([href, label]) => ({ href, label }))

  if (crumbs.length === 0) return null

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1
          // On small screens only the current page is shown.
          const hideOnMobile = !isLast ? "hidden md:inline-flex" : undefined
          return (
            <Fragment key={crumb.href}>
              <BreadcrumbItem className={hideOnMobile}>
                {isLast ? (
                  <BreadcrumbPage className="max-w-[16rem] truncate font-medium">{crumb.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.href}>{crumb.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator className="hidden md:block" />}
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
